// https://cogoport.github.io/cogo-toast/

import toast from 'cogo-toast'
export default toast